import React, { useState } from 'react';
import { useAuth } from '../../components/auth/AuthContext';
import { useOFEFetch } from './useOFE';

const SEV_COLORS = { critical: 'text-red-400 bg-red-900/20 border-red-800', major: 'text-yellow-400 bg-yellow-900/20 border-yellow-800', minor: 'text-gray-300 bg-gray-800 border-gray-700' };

export default function OFECxIssues() {
  const { user } = useAuth();
  const [severity, setSeverity] = useState('');
  const [status, setStatus] = useState('open');
  const query = [severity && `severity=${severity}`, status && `status=${status}`].filter(Boolean).join('&');
  const { data: issues, loading } = useOFEFetch(`/ofe/cx/issues${query ? '?' + query : ''}`, user, [severity, status]);

  return (
    <div className="p-6 space-y-4">
      <div className="flex items-center gap-4">
        <h1 className="text-xl font-bold text-white">Cx Issues</h1>
        <div className="ml-auto flex gap-2">
          <select value={severity} onChange={e => setSeverity(e.target.value)}
            className="bg-gray-800 border border-gray-600 text-white px-3 py-1.5 rounded text-sm">
            <option value="">All severities</option>
            <option value="critical">Critical</option>
            <option value="major">Major</option>
            <option value="minor">Minor</option>
          </select>
          <select value={status} onChange={e => setStatus(e.target.value)}
            className="bg-gray-800 border border-gray-600 text-white px-3 py-1.5 rounded text-sm">
            <option value="open">Open</option>
            <option value="in_progress">In Progress</option>
            <option value="resolved">Resolved</option>
            <option value="">All</option>
          </select>
        </div>
      </div>

      {loading && <div className="text-gray-400">Loading...</div>}

      <div className="space-y-3">
        {(issues || []).map(issue => (
          <div key={issue.id} className={`border rounded-lg p-4 ${SEV_COLORS[issue.severity] || 'bg-gray-800 border-gray-700'}`}>
            <div className="flex items-center gap-3 mb-2">
              <span className="text-xs px-2 py-0.5 rounded-full bg-black/20 font-semibold">{issue.severity}</span>
              <span className="text-white font-semibold">{issue.title}</span>
              <span className="font-mono text-xs text-gray-400 ml-1">{issue.project_allocation}</span>
              <span className="ml-auto text-gray-400 text-xs">{issue.created_at?.slice(0, 10)}</span>
            </div>
            <p className="text-sm text-gray-300">{issue.description}</p>
            <div className="flex items-center gap-4 mt-2 text-xs text-gray-400">
              <span>Type: {issue.issue_type}</span>
              {issue.assigned_to && <span>Assigned: {issue.assigned_to}</span>}
              {issue.due_date && <span className={issue.due_date < new Date().toISOString().slice(0,10) ? 'text-red-400' : ''}>Due: {issue.due_date}</span>}
              {issue.cxalloy_ref && <span>CxAlloy: {issue.cxalloy_ref}</span>}
            </div>
          </div>
        ))}
        {!issues?.length && !loading && <div className="text-center py-12 text-gray-500">No Cx issues found</div>}
      </div>
    </div>
  );
}
